import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Inbox, CalendarDays, BookOpen, Sparkles, ArrowUpRight, Loader2, Ticket } from "lucide-react";
import { SCHEMAS } from "@/pages/admin/schemas";

export default function Dashboard() {
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/dashboard").then((r) => setD(r.data)).catch(() => setD({ counts: {}, recent: [] }));
  }, []);

  if (!d) return <div className="flex justify-center py-20"><Loader2 className="animate-spin text-[#2CACD4]" /></div>;

  const cards = [
    { label: "Events", key: "events", icon: CalendarDays, to: "/admin/events", accent: "#2CACD4" },
    { label: "New submissions", key: "submissions_new", icon: Inbox, to: "/admin/submissions", accent: "#CAE295" },
    { label: "RSVPs", key: "rsvps_total", icon: Ticket, to: "/admin/rsvps", accent: "#DB1A5C" },
    { label: "Initiatives", key: "initiatives", icon: Sparkles, to: "/admin/initiatives", accent: "#2CB6C2" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display font-black uppercase text-3xl">Dashboard</h1>
      <p className="mt-1 text-muted-foreground">Everything that powers the public site, in one place.</p>

      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {cards.map((c) => (
          <Link key={c.key} to={c.to} className="group rounded-2xl bg-card border border-border p-5 hover:shadow-lg hover:-translate-y-0.5 transition-all cursor-pointer" data-testid={`dash-card-${c.key}`}>
            <span className="flex h-11 w-11 items-center justify-center rounded-xl" style={{ background: `${c.accent}22`, color: c.accent }}><c.icon size={20} /></span>
            <p className="mt-4 font-display font-black text-4xl">{d.counts[c.key] ?? 0}</p>
            <p className="text-sm text-muted-foreground flex items-center gap-1">{c.label} <ArrowUpRight size={13} className="opacity-0 group-hover:opacity-100 transition-opacity" /></p>
          </Link>
        ))}
      </div>

      <div className="mt-10 grid gap-8 lg:grid-cols-2">
        <div>
          <h2 className="font-display font-black uppercase text-lg mb-4">Manage content</h2>
          <div className="grid grid-cols-2 gap-2">
            {Object.entries(SCHEMAS).map(([key, s]) => (
              <Link key={key} to={`/admin/${key}`} className="flex items-center justify-between rounded-xl border border-border bg-card px-4 py-3 text-sm font-semibold hover:border-[#2CACD4] transition-colors cursor-pointer">
                {s.label}
                <span className="text-muted-foreground">{d.counts[key] ?? 0}</span>
              </Link>
            ))}
          </div>
        </div>

        <div>
          <h2 className="font-display font-black uppercase text-lg mb-4">Recent activity</h2>
          <div className="rounded-2xl border border-border bg-card divide-y divide-border">
            {(d.recent || []).length === 0 && <p className="p-5 text-sm text-muted-foreground">No activity yet.</p>}
            {(d.recent || []).map((r) => (
              <div key={r.id} className="p-4 text-sm">
                <p><span className="font-bold capitalize">{r.action}</span> {r.entity} <span className="text-muted-foreground">· {r.user_email}</span></p>
                <p className="text-xs text-muted-foreground mt-0.5">{new Date(r.at).toLocaleString()}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
